import styled from '@emotion/styled';
import Radio from '@mui/material/Radio';

const StyledRadioButton = styled(Radio)`
  color: ${({ theme }) => theme.palette.grey[40]};
  &:hover {
    color: ${({ theme }) => theme.palette.primary.main};
    background-color: transparent;
  }
  &.Mui-disabled {
    color: ${({ theme }) => theme.palette.grey[5]};
  }
`;

export const RadioButton = StyledRadioButton;
